export default __webpack_public_path__ + "static/media/Illustration_Home.bfa909e2.webp";